var React = require('react');

function Signup (props) {
    return React.createElement("svg",props,React.createElement("path",{"clipRule":"evenodd","d":"M12 3C14.7614 3 17 5.23858 17 8C17 10.7614 14.7614 13 12 13C9.23858 13 7 10.7614 7 8C7 5.23858 9.23858 3 12 3ZM12 4C9.79086 4 8 5.79086 8 8C8 10.2091 9.79086 12 12 12C14.2091 12 16 10.2091 16 8C16 5.79086 14.2091 4 12 4ZM12 15C15.5265 15 18.4439 17.6077 18.9291 21H17.917C17.441 18.1623 14.973 16 12 16C9.02701 16 6.55904 18.1623 6.08296 21H5.07089C5.55612 17.6077 8.47353 15 12 15Z"}));
}

Signup.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Signup;

Signup.default = Signup;
